import React, { useEffect } from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './roomVo.module.scss';

const cx = classNames.bind(styles);

export const RoomVo = ({ itemId }) => {
  const ROOMVO_SCRIPT_SRC = 'https://cdn.roomvo.com/static/scripts/b2b/homedepot.js';

  useEffect(() => {
    let scripts = [];
    if (typeof window !== 'undefined' && window.document) {
      scripts = Array.from(document.getElementsByTagName('script'));
    }
    const loadedRoomVoScript = scripts.find((script) => script.getAttribute('src') === ROOMVO_SCRIPT_SRC);

    if (!loadedRoomVoScript && itemId) {
      const script = document.createElement('script');
      script.src = ROOMVO_SCRIPT_SRC;
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      if (loadedRoomVoScript?.parentNode) {
        loadedRoomVoScript.parentNode.removeChild(loadedRoomVoScript);
      }
    };
  }, []);

  if (!itemId) return null;
  const SUB_HEADING = 'See This In My Room';

  return (
  /* Note: roomvo-container div & roomvo-stimr class are added as per the requirements from the roomvo 3rd party
    and should not be removed. */
    <div className={cx('roomvo-container')}>
      <div className={cx('roomvo-wrapper')}>
        <Button
          cta
          className={cx('roomvo', 'roomvo-stimr')}
          contentClass={cx('roomvo-bttn')}
          data-sku={itemId}
        >
          <div className={cx('roomvo__sub-heading')}>{SUB_HEADING}</div>
        </Button>
      </div>
    </div>
  );
};

RoomVo.displayName = 'RoomVo';

RoomVo.propTypes = {
  itemId: string.isRequired
};
